<template>
  <div class="h5-label-page">
    {{ text }}
  </div>
</template>

<script>
import api from '../../api/index'
export default {
  data () {
    return {
      id: '',
      // number: '',
      text: ''
    }
  },
  created () {
    if (this.$route.query.id) {
      this.id = this.$route.query.id
      // if (this.$route.query.number) {
      //   this.number = this.$route.query.number
      // }
    }
  },
  mounted () {
    this.getLabelDetails()
  },
  methods: {
    getLabelDetails () {
      if (this.id) {
        var param = {
          pass: this.id
        }
        // if (this.number) { param.number = this.number }
        api.hbInformationSignsCipher(param).then(res => {
          if (res.code === 200) {
            this.text = res.data
          }
        })
      }
    }
  }
}
</script>

<style lang="scss">
.h5-label-page {
  width: calc(100vw - 40px);
  height: calc(100vh - 40px);
  // text-align: center;
  font-size: 20px;
  padding: 20px;
  word-break: break-word;
  white-space: pre-line;
}
</style>
